module.exports = __webpack_public_path__ + "media/images/pc/stores/common/appeal_01-82d7f2eec936f3ef2c3db95101c2995e.webp";